import { render, staticRenderFns } from "./mfa-sms.vue?vue&type=template&id=6b668bf7&scoped=true&"
import script from "./mfa-sms.vue?vue&type=script&lang=js&"
export * from "./mfa-sms.vue?vue&type=script&lang=js&"
import style0 from "./mfa-sms.vue?vue&type=style&index=0&id=6b668bf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b668bf7",
  null
  
)

export default component.exports